module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("What They Didn’t Teach You in Spanish Class")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach1",
      "title": "Chapter 1. Meet & Greet"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_7",
      "title": "7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch1"
    }
  }, [_vm._v("Meet & Greet")])]), _vm._v(" "), _c('p', {
    staticClass: "h2a1"
  }, [_vm._v("Los Coloqueos")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spanish speakers in a friendly (or alcoholic) environment rarely start conversations with an “"), _c('i', [_vm._v("Hola")]), _vm._v("” or “"), _c('i', [_vm._v("Buen día")]), _vm._v(".” It’s more casual and common to head straight for a question, even if it hangs in the air as hypothetical and unanswered; as in English, it’s also not that strange to answer a question like "), _c('i', [_vm._v("¿Qué onda?")]), _vm._v(" with"), _c('i', [_vm._v("…the same exact question.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("What’s up?")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¿Qué tal?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’d I miss?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué pasó?; ¿Quihubo?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’s up guys?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué hay de nuevo, muchachos?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What up?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué onda?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’s goin’ on?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué sapa?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('i', [_vm._v("Qué pasa")]), _vm._v(" in corny anagram.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’re you up to?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué haces?")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxh"
  }, [_vm._v("WHAT’S UP?")]), _vm._v(" "), _c('p', {
    staticClass: "boxh1"
  }, [_vm._v("¿QUÉ TAL?")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¿Qué tal-co?")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¿Qué tal andas?")]), _vm._v(" (Spn)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¿Qué jais?")]), _vm._v(" (Mex)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¿Qué volá?")]), _vm._v(" (Carib)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¿Qué más?")]), _vm._v(" (Andes)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¿Qué’s la que hay?")]), _vm._v(" (PuR)")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_c('b', [_vm._v("What’s the good word")]), _vm._v(", Fatty?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué dices, Gordo?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent00"
  }, [_vm._v("Many greetings sound best followed by an affectionate, mildly offensive epithet (Tubby, Pizzaface, Nancy, Bigballs, whatever).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whatcha got?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿A ver?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What the cock (have you been up to)?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿A verga?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_8",
      "title": "8"
    }
  }, [_c('b', [_vm._v("What else")]), _vm._v(" is new with you?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("De tu vida, ¿qué más?")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("How you doing?")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¿Cómo andas?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once you’re done with the initial niceties and greetings, it’s time to dig a little deeper and inquire about the person’s life. Vague, fragmentary answers are the norm, so don’t expect a lengthy response, or even a complete sentence.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How are you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Cómo estás?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How’s it goin’?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Cómo te va?; ¿Cómo le va?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("To be chummy but still respectful, use the second one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How you doin’?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Cómo andas?")]), _vm._v(" | "), _c('i', [_vm._v("¿Cómo andamio?")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How’s life?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Cómo anda la vida?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How ’bout things with you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Y tus cosas?")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Kickin’ ass!")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("¡De pelos!")]), _vm._v(" | "), _c('i', [_vm._v("¡A toda madre!")]), _vm._v(" (Mex) | "), _c('i', [_vm._v("¡De butaca!")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Straight chillin’.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("¡Todo tránqui’!")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("I’m all right.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Ando ahí nomás.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("It’s all good!")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Todo [va] bien.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Same as ever.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Como siempre.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Still kicking around here, aren’t I?")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Sigo por aquí, no?")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Still here.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Aquí nomás.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Everything’s super.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Todo a full.")]), _vm._v(" | "), _c('i', [_vm._v("…full de to’.")]), _vm._v(" (Carib)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("En marcha.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Never better.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Nunca mejor.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Great.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("A todo dar.")]), _vm._v(" (LatAm)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_9",
      "title": "9"
    }
  }, [_vm._v("Super.")])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("De órdago.")]), _vm._v(" (Spn)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Awesome.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Increíble.")]), _vm._v(" | "), _c('i', [_vm._v("Guay.")]), _vm._v(" (Spn)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("I can’t complain.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("No me quejo.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("It is what it is.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Es lo que sea.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("It’s whatever.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Me da lo mismo.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Shitty.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Una cagada.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Fucking crappy.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Como el orto.")]), _vm._v(" (S.Am)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Fucked up.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Jodido.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("I’m in a bad fucking mood.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Vengo encabronado.")])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Estoy encabronado")]), _vm._v(" would be more literal, but "), _c('i', [_vm._v("vengo")]), _vm._v(" is kind of a warning to the listener that the bad mood’s been on for a while.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("How’s life, really?")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¿Pero en serio, cómo te va la vida?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Even if your friend didn’t mention any girl/boy/work/family troubles last time you talked, it’s fair game to ask them about it point-blank if you’ve heard things through the grapevine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’s the deal with…?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué onda con…?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’s the latest with…?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué cuentas sobre…?; ¿Qué se cuenta de…?")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("your old lady")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("la vieja")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("the ball-n-chain")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("la jefa")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("the ball-buster")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("la domadora")])]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("literally, “stud-breaker”")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "imagei"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_10",
      "title": "10"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "96",
      "src": "images/f0010-01.jpg",
      "width": "173"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "left00"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Captain Dudepants")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("el capitán")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Main Fellow")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("el mariscal")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("your folks")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("los viejos")]), _vm._v(" | "), _c('i', [_vm._v("los tatas")]), _vm._v(" (Mex)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The whole situation is "), _c('b', [_vm._v("seriously fucked")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Todo el asunto está seriamente jodido.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I don’t even wanna talk about it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Ni hablar.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What’s happenin’ with that "), _c('b', [_vm._v("little venture")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Que pasó con ese bisnes?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("How’d that "), _c('b', [_vm._v("gig")]), _vm._v(" work out?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué pasó con ese curro?")]), _vm._v(" (Spn) | "), _c('i', [_vm._v("…esa chamba?")]), _vm._v(" (Mex) |")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("…esa changa?")]), _vm._v(" (S.Cone) | "), _c('i', [_vm._v("…ese camello?")]), _vm._v(" (Andes)")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Gettin’ paid")]), _vm._v(", at least.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Me pagan, por lo menos.")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("They’re really "), _c('b', [_vm._v("wiping their asses")]), _vm._v(" with me.")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("Me están pasando por el culo.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Clueless")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("Despistado")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I dunno…")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("No sé…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I don’t know what to tell you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("No sabría qué decirte.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have no clue.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("No tengo ni idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I have no fucking idea.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Ni puta idea.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What do I know?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Qué se yo?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("God only knows.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Sepa el Señor.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_11",
      "title": "11"
    }
  }, [_vm._v("How "), _c('b', [_vm._v("the fuck")]), _vm._v(" would I know?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Y yo, qué mierda sé?")]), _vm._v(" | "), _c('i', [_vm._v("…qué coño…")]), _vm._v(" (Spn, Carib) |")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("…qué cojones…")]), _vm._v(" (Mex)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Who knows?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Sepa Fulano.")]), _vm._v(" | "), _c('i', [_vm._v("…Pancha.")]), _vm._v(" (Mex) |"), _c('i', [_vm._v("…Moya.")]), _vm._v(" (Chi)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Literally, “Random dude knows.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Fucked if I know.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Sepa la bola!")]), _vm._v(" | "), _c('i', [_vm._v("…la chingada!")]), _vm._v(" (Mex)")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Look who showed up!")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¡Mira quién apareció!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s common among good friends to express exaggerated surprise or joy at an arrival, particularly a late one. These expressions seem dramatic in English, but they are a normal part of interacting in Spanish-speaking lands. It’s common in these situations to call someone by a nickname that would, in other contexts, be way more offensive, like "), _c('i', [_vm._v("pendejo de mierda")]), _vm._v(" (total fucker) or "), _c('i', [_vm._v("hijo de la gran puta")]), _vm._v(" (son of a royal whore).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Long time no see!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Tanto tiempo!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("You made it")]), _vm._v(", dummy!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Caíste, salame!")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("They let you out!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Te dejaron salir!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here he is, "), _c('b', [_vm._v("back from the dead")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Uppaa, llegó el desaparecido!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("Careful with this one in the Southern Cone, where "), _c('i', [_vm._v("los desaparecidos")]), _vm._v(" refers to people who “disappeared” during various murder-happy dictatorships.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What the heck are you doing here?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Y tú, qué haces por aquí?")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxh"
  }, [_vm._v("DID I STUTTER?")]), _vm._v(" "), _c('p', {
    staticClass: "boxh1"
  }, [_vm._v("¿TARTAMUDEO?")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb1"
  }, [_vm._v("There’s lots of meaningless filler-words that people use to “um” and “uh” their way to an answer, particularly to a question they found too direct. In informal settings, talk radio, and TV news, you hear these all the time, often unconsciously peppered throughout everything people say.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("…I guess…")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("…o sea…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("…it’s that…")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("…es que…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("…I mean…")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("…digo…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("…what some people call…")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("…lo que se llama…")])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_12",
      "title": "12"
    }
  }, [_vm._v("Great to see you!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Qué alegría verte!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You look great!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Qué pinta!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where’ve you been hidin’?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Dónde te has metido?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You fell off the face of the earth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Te esfumaste de la faz de la tierra.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Speak of the devil, and he doth appear.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Hablando del Rey de Roma, por la puerta")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "126",
      "src": "images/f0012-01.jpg",
      "width": "112"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_c('i', [_vm._v("asoma;…el burro se asoma.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This curious nickname for Satan actually dates back to the period of Papal exile in Avignon (1309 – 77), during which the “king” (technically Pontifice) of Rome was seen as a major heretic that the Church had to move to France to avoid. "), _c('i', [_vm._v("Asomar")]), _vm._v(" is a poetic botanical metaphor for “popping up” that conveniently rhymes with Roma; and "), _c('i', [_vm._v("el burro")]), _vm._v(" is the variation you use when you want to sneak in a jab at the intelligence of the Dark Prince in question.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You’ve put on a few [pounds] since the last time I saw you, Chubs!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Te engordaste un par [de kilos], Rechonchito!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Just when "), _c('b', [_vm._v("we were too few")]), _vm._v(", and then…")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Tras que éramos pocos, y…")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("For as clunky and sarcastic as it sounds in English, this is actually a fairly common, if folksy, way of announcing that you’re happy to see someone.")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Doofus")]), _vm._v(" drops by!")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("cayó el tronco!")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("my brother hired a "), _c('b', [_vm._v("drag queen")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("mi hermano trajo un travestí!")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("the wild beast/the deaf girl/so-and-so")]), _vm._v(" showed up!")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("llegó la bestia/la sorda/fulano!")])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('b', [_vm._v("Granny")]), _vm._v(" gave birth!")]), _vm._v(" "), _c('p', {
    staticClass: "left0"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('i', [_vm._v("parió la abuela!")])]), _vm._v(" "), _c('p', {
    staticClass: "left0a"
  }, [_c('span', {
    staticClass: "hide"
  }), _vm._v("Don’t ask me why this perverse spectacle would make for a kick-ass party…but it is somehow a common saying!")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Hey!")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¡Oye!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At some point, you’ll probably need to catch someone’s attention in a crowded street, open-air market, bar fight, or orgy. There are a bunch of ways to do so, but most are pretty regional—there’s no universal “hey” aside from "), _c('i', [_vm._v("oye")]), _vm._v(" (listen) and "), _c('i', [_vm._v("mira")]), _vm._v(" "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_vm._v("(look), and even those have regional connotations (like in Argentina, where they sound more confrontational, like “listen up!”).")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hey!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Oye!")]), _vm._v(" | "), _c('i', [_vm._v("¡Aguas!")]), _vm._v(" (Mex) | "), _c('i', [_vm._v("¡Mare!")]), _vm._v(" (Mex) | "), _c('i', [_vm._v("¡Ala!")]), _vm._v(" (Andes) | "), _c('i', [_vm._v("¡Che!")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Che")]), _vm._v(" is a trademark of the Argentine dialect, where it means both “hey” and “guy.” Borges once “Argentinized” the story of Caesar and Brutus by substituting the famous “"), _c('i', [_vm._v("et tu, Brutus")]), _vm._v("?” with an angry “"), _c('i', [_vm._v("¡Pero, che!")]), _vm._v("”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hey, man!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Quetá, compa!")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxh"
  }, [_vm._v("WOW!")]), _vm._v(" "), _c('p', {
    staticClass: "boxh1"
  }, [_vm._v("¡CARAMBA!")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb1"
  }, [_vm._v("If you want to sound like a hokey Ned Flanders anywhere in the Spanish-speaking world, then go ahead and use "), _c('i', [_vm._v("caramba")]), _vm._v(". If not, here are some regional-specific alternatives.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¡Fua!")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¡Úchale!")]), _vm._v(" (Mex)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¡Diay!")]), _vm._v(" (CenAm)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¡Caray!")]), _vm._v(" (Andes)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¡Gua!")]), _vm._v(" (Spanglish)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("¡Hala!")]), _vm._v(" (Spn)")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_vm._v("Hey, now!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Épale!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Watch out!/Eeeasy there.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Eeeeeeh-pa!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Look!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Mira!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Listen!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Oye!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Listen up, deaf guy!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Oye, sordo!")]), _vm._v(" | "), _c('i', [_vm._v("¡Oye, teniente!")]), _vm._v(" (Spn)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Wake up, space-cadet!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Oye, ausente!; ¡Oye, zombi!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("That’s fucked up!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Qué mierda!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Check this out!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Chéquele!")]), _vm._v(" | "), _c('i', [_vm._v("¡Chécate esto!")]), _vm._v(" (Mex)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Check out that")]), _vm._v(" hairy guy’s "), _c('b', [_vm._v("back-bush")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Cheque la barba dorsal que tiene ese gorila!")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_14",
      "title": "14"
    }
  }, [_vm._v("Seriously?")])]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¿En serio?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What with all that subjunctive mood floating around, Spanish speakers tend to insist (and inquire) more often than English speakers about veracity.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No way!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡No me digas!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Jesus Christ!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Cristo mío!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Holy shit!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Dio[s] mío!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I can’t believe it!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡No lo puedo creer!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Really?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿De veras?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Are you for real?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Estás serio/a?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Give it to me straight.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Dime la dura!")]), _vm._v(" | "), _c('i', [_vm._v("…la firme!")]), _vm._v(" (Peru) | "), _c('i', [_vm._v("…la posta!")]), _vm._v(" (S.Cone) |")]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_c('i', [_vm._v("…la fetén!")]), _vm._v(" (Spn) | "), _c('i', [_vm._v("…la neta!")]), _vm._v(" (CenAm)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Yeah?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Sí?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You think?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Te parece?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Na-ah.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Ni modo.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hell yeah!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Del todo!")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Saying your goodbyes")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("Hacer las despedidas")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spanish farewells are a blank check for corniness. "), _c('i', [_vm._v("Ciao")]), _vm._v(", the most common slang for “good-bye,” is sometimes spelled phonetically, so don’t be baffled by a "), _c('i', [_vm._v("chau")]), _vm._v(" or a "), _c('i', [_vm._v("chao")]), _vm._v(" on a billboard or in a comic book.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a while, crocodile.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Chaufa.")]), _vm._v(" (Per)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("This is a horrible Peruvian pun on Chinese food: "), _c('i', [_vm._v("ciaofun")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Lates!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Chabela!; ¡Chavela!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("From "), _c('i', [_vm._v("Ciao, bella. Ciao")]), _vm._v(" is so common that many Latin Americans would be surprised if you told them it’s actually Italian.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_15",
      "title": "15"
    }
  }, [_vm._v("Bye, y’all.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Chado.")]), _vm._v(" (Col)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent00"
  }, [_vm._v("This is a pretty rural term.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("See ya around!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Ahí nos vemos!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("See ya in a bit!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Ahí nos vidrios!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m leaving.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Me voy.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s roll.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Larguémonos.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s get outta here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Ahuéquemos el ala.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m splitsville.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Me marcho.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m gonna split.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Salgo rajando.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I gotta bounce.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Tengo que huir.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Take care!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Ciúdate!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("We’re outta here.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Nosotros nos huimos.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("See ya "), _c('b', [_vm._v("later")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Hasta luego!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Toodles!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Ahí nos Belmont!")]), _vm._v(" (S.Am)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent00"
  }, [_vm._v("Belmont sounds like “"), _c('i', [_vm._v("vemos")]), _vm._v("” (see ya) but is also the name of an ubiquitous brand of cheap Venezuelan cigarettes. Sounds Venezuelan, right?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Text me!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Mensajéame!; ¡Textéame!")])]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "103",
      "src": "images/f0015-01.jpg",
      "width": "61"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_vm._v("Call me later!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Llámame luego!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_16",
      "title": "16"
    }
  }, [_vm._v("L8R.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Elejota.")]), _vm._v(" (Chi)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent00"
  }, [_vm._v("The phonetic pronunciation of "), _c('i', [_vm._v("L.J.")]), _vm._v(", which is the abbreviation for "), _c('i', [_vm._v("los juimos")]), _vm._v(", Chilean slang for “Let’s go.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Until next time!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Hasta la próxima!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Smell ya later!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Hasta el cante!")]), _vm._v(" (Spn) | "), _c('i', [_vm._v("¡Hasta el hornazo!")]), _vm._v(" (Mex) | "), _c('i', [_vm._v("¡Hasta la chucha!")]), _vm._v(" (Andes) | "), _c('i', [_vm._v("¡Hasta la baranda!")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Sorry")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("Sori")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In Spanish, you don’t so much apologize as plead distraction, momentary lapse of reason, ill luck, or simply general incompetence. Most Spanish speakers use self-deprecation to extract themselves from a sticky situation rather than beg forgiveness. So if you get caught cheating on your girlfriend or boyfriend, just say, “Whoops, aren’t I the sillyhead!” and then grin until your cheeks hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Sorry!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Perdón!; ¡Sorri!; ¡Sori!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m really, really sorry!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Lo siento muchísimo!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My bad.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Emece.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent00"
  }, [_vm._v("As in “M.C.”: mea culpa.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ooops!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Ufa!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s totally my fault.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Tengo todo la culpa.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("My deepest "), _c('b', [_vm._v("apologies")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Mil disculpas!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I crossed the line.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Me pasé de la raya.")])]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_17",
      "title": "17"
    }
  }, [_vm._v("BLESSINGS AND GRACES")])]), _vm._v(" "), _c('p', {
    staticClass: "boxh1"
  }, [_vm._v("BENDICIONES Y GRACIAS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb1"
  }, [_vm._v("Catholicism is widespread in Latin America. And just as the British will say “Cheers” as you hand them an Alcoholics Anonymous pamphlet, many Spanish speakers will literally bless you even if you’re wearing a giant star of David.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("May God protect and keep you. (Formal)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("Que Dios le proteja y cuide.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("May God go with you. (Familiar)")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("Que vaya Dios contigo.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("May God watch over you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("Que Dios te guarde.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('b', [_vm._v("I pray to God that")]), _vm._v(" my car won’t fail me again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Ojalá que no me falle el coche de nuevo.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_vm._v("Fun fact: this phrase is actually borrowed from the Andalucian Arabic "), _c('i', [_vm._v("law-sha-Allah")]), _vm._v(", or “if Allah wills it.”")]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_vm._v("Forgive me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Perdóname.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m so embarrassed!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Qué vergüenza!")]), _vm._v(" | "), _c('i', [_vm._v("¡Qué corte me da!")]), _vm._v(" (Spn)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What a stupid thing to do!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Qué idiotez!; ¡Qué huevada!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What a fuck-up!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Qué cagazón!")]), _vm._v(" (Mex) | "), _c('i', [_vm._v("¡Qué boludez!")]), _vm._v(" (S.Cone)")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Get over it")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("Aguántatelo")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("If apologizing doesn’t get you off the hook, you should move for a full dismissal of charges with appeals to a big picture or friendly license that might seem out of bounds in North American culture.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s not get carried away.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("No es para tanto.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It’s not what it looks like!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡No es lo que parece!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I didn’t mean to do that at all.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Lo hice sin querer para nada.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It was an honest mistake!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Fue sin querer!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I didn’t mean to shit in your "), _c('b', [_vm._v("bidet")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Cagué en tu bidé sin querer!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oh, don’t "), _c('b', [_vm._v("make a scene")]), _vm._v("!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Ay, no armes un escándolo!")]), _vm._v(" | "), _c('i', [_vm._v("¡Deja el show!")]), _vm._v(" (PuR)")]), _vm._v(" "), _c('p', {
    staticClass: "image1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "boxh"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_18",
      "title": "18"
    }
  }, [_vm._v("WHEN IN ROME…DON’T CALL THEM ROMANS")])]), _vm._v(" "), _c('p', {
    staticClass: "boxh1"
  }, [_vm._v("CUANDO VAYAS A ROMA, NO LES LLAMES ROMANOS")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb1"
  }, [_vm._v("Know how people in New York like to call themselves New Yorkers and say they live in The City? Well, they stole that habit from Spanish speakers just like they stole Manhattan from the Indians. Here’s a handy chart of the affectionate names Spanish speakers call themselves and their cities.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('b', [_vm._v("People who live in:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Buenos Aires")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Madrid")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Barcelona")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Mexico City")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Guadalajara")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Guatemala City")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Lima")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("El Salvador")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_vm._v("Nicaragua")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb1"
  }, [_vm._v("Costa Rica")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('b', [_vm._v("Call themselves:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Porteños")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Madrileños, Gatos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Barceloneses")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Chilangos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Tapatíos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Chapines")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Limeños, Zapallos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Guanacos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Nicas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb1"
  }, [_c('i', [_vm._v("Ticos")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('b', [_vm._v("And their city:")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Baires, Buesas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("El Foro")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Barna, Barça")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("El Monstruo")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Guanatas")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb0"
  }, [_c('i', [_vm._v("Guate")])]), _vm._v(" "), _c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "5",
      "src": "images/line.jpg",
      "width": "800"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_vm._v("Take it easy.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Tómalo con calma.")]), _vm._v(" | "), _c('i', [_vm._v("Cógelo suave.")]), _vm._v(" (Carib)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Chill out, man, it’s "), _c('b', [_vm._v("just a dribble")]), _vm._v(" of wine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Calma, hombre, es un chorrito de wine nomás.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("’Scuse me")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("’Miso")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Latins don’t have many ways of saying “excuse me.” As the old saying goes, "), _c('i', [_vm._v("mejor pedir perdón que pedir permiso")]), _vm._v(" (Better to apologize later than ask permission beforehand).")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Excuse me.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Con permiso.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Scus’ee.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Permiso.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Meepmeep!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("’Miso-miso!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("Make way")]), _vm._v(", I’m in a rush.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Abre paso, vengo apurado.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Watch out!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Cuidado!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Back in a flash!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Vuelvo al tiro!")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_19",
      "title": "19"
    }
  }, [_vm._v("Please")])]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("Porfa")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Spanish slang is supertheatrical. You’ll often see adults pleading like children for a simple favor. That’s because you don’t merely ask someone for something; you paint them as your supreme benefactor, a noble gaucho who would forever be immortalized in song if they could somehow bring it upon themselves to pass the god-damn salt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pleeeeease!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Poorfaa!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pretty please!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Plis-plis!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Please do me "), _c('b', [_vm._v("the favor")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Por favor, hágame el favor.")]), _vm._v(" | "), _c('i', [_vm._v("…la gauchada.")]), _vm._v(" (S.Cone) | "), _c('i', [_vm._v("…la volada.")]), _vm._v(" (CenAm)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m begging you!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Te lo ruego!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("You scratch my back and I’ll scratch yours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Hazme un cambalache!")]), _vm._v(" | "), _c('i', [_vm._v("...el cruce!")]), _vm._v(" (Col)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Please "), _c('b', [_vm._v("have the decency")]), _vm._v(" to shut that gossiping mouth of yours.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Tenga la bondad de callar esa boca chismosa, por favor.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Help me out!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¡Échame una mano!")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Can you do me a favor?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Me harías una cosita?")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("Good to meet ya")]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("Un placer darte a conocer")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After meeting someone, it’s nice to express your pleasure at having done so. People like to be liked. Go figure.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I’m charmed.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Encantado.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Pleased to meet you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Mucho gusto.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_vm._v("There’s also the less formal "), _c('i', [_vm._v("‘chogusto.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The pleasure is all mine.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("El placer es todo mío.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Likewise.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Igualmente.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Have a good one.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Que te vaya bien.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hopefully, we’ll "), _c('b', [_vm._v("bump into each other")]), _vm._v(" again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("A ver si nos encontramos por ahí.")])]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_20",
      "title": "20"
    }
  }, [_vm._v("What do you do for fun?")])]), _vm._v(" "), _c('p', {
    staticClass: "h4a"
  }, [_vm._v("¿Cómo te diviertes?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Once you’ve established that someone’s gonna be at your table for a while and you’ve exhausted all small talk, it’s far more acceptable than in the U.S. to press for personal details.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("What do you do to kill the time?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Cómo matas las horas?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where are "), _c('b', [_vm._v("your people")]), _vm._v(" from?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿De dónde viene tu gente?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent00"
  }, [_vm._v("Here “your people” would refer to one’s extended family or “kin,” not to their race or ethnicity as in North American usage.")]), _vm._v(" "), _c('figure', [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "70",
      "src": "images/f0020-01.jpg",
      "width": "157"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "noindentaa"
  }, [_vm._v("How long have you lived in the city?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Desde cuándo has vivido en la ciudad?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where were you raised?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Dónde te criaste?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Can you show me around the city?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Me podrías pasear por la ciudad?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("I don’t know "), _c('b', [_vm._v("anyone")]), _vm._v(" here, can I sit with you?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("No conozco a un alma aquí, ¿podría sentarme contigo?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Let’s meet up later tonight, what do you say?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("Nos juntemos a la tarde, ¿que te parece?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("How single")]), _vm._v(" are you, exactly?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Cuán soltero estás, de hecho?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Where’d you learn "), _c('b', [_vm._v("to open bottles")]), _vm._v(" like that?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Dónde aprendiste descorchar botellas así?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Would you give me "), _c('b', [_vm._v("a private lesson")]), _vm._v("?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Me darías una lección privada?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("What team do you play for")]), _vm._v(", if you don’t mind my asking?")]), _vm._v(" "), _c('p', {
    staticClass: "noindent0"
  }, [_c('i', [_vm._v("¿Para qué equipo juegas, si no te molesta la pregunta?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b81305f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter001.vue
// module id = 75
// module chunks = 0